import  React, { ReactChildren } from 'react'
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
//import moment from 'moment';


interface ISystemLabel  {
    dateOfBirth: any
}


export default class SystemAge extends SystemBase<ISystemLabel>
{
    constructor(props: any) {
        super(props)
    }

    render() {
        var from: Date = typeof this.props.dateOfBirth == "string" ? new Date(this.props.dateOfBirth) : this.props.dateOfBirth

        //let fromDate = moment(from.toISOString())
        //let toDate = moment();
        //let years = toDate.diff(fromDate, 'years')
        //fromDate.add(years, 'years')
        //let months = toDate.diff(fromDate, 'months')
        //fromDate.add(months, 'months')
        //let days = toDate.diff(fromDate,'days')


        //let age = '';
        //if (!(years === 0)) { age = years + (years > 1 ? ' years ': ' year ') }
        //if (!(months === 0)) { age = age + months + (months > 1 ? ' months ' : ' month ' )}
        //if (!(days === 0)) { age = age + days + (days > 1 ? ' days ' : ' day ') }



        return (
            <this.WrapperDiv>
                <span className="font-weight-bolder">{ "ss" }</span>
            </this.WrapperDiv>
        );
    }
}
